<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <a-form layout="inline" :labelCol="{ style: { width: '90px' } }">
        <a-row>
          <a-col :md="6" :sm="24">
            <a-form-item label="发货预测名称">
              <global-select
                @change="()=>{queryParams.shipmentForecastVersionList=undefined}"
                :value.sync="queryParams.shipmentForecastName"
                selectType="selectSearch"
                requestApi="/scp/scpSopShipmentForecast/listShipmentForecastName"
                :selectItem="{ value: 'realValue', label: 'label' }"
                searchParam="name"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="版本">
              <global-select
                :setParams="{ name: queryParams.shipmentForecastName }"
                :value.sync="queryParams.shipmentForecastVersionList"
                selectType="selectSearch"
                requestApi="/scp/scpSopShipmentForecast/listShipmentForecastVersion"
                :selectItem="{ value: 'realValue', label: 'label' }"
                searchParam="version"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="状态">
              <global-select
                :value.sync="queryParams.statusList"
                selectType="selectSearch"
                requestApi="/scp/scpSopShipmentForecast/listShipmentForecastStatus"
                :selectItem="{ value: 'realValue', label: 'label' }"
                searchParam="status"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button @click="onSearch" type="primary">查询</a-button>
              <a-button @click="resetQuery" class="ml8">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="table-page-operator-wrapper" slot="btn">
      <a-button @click="handleAdd" type="primary" v-hasPermi="['scp:scpSopShipmentForecast:createShipmentForecast']">新建</a-button>
      <a-button @click="handleCalculation" v-hasPermi="['scp:scpSopShipmentForecast:startCalculate']">启动计算</a-button>
      <a-button @click="handleStopCalculation" v-hasPermi="['scp:scpSopShipmentForecast:stopCalculate']">终止计算</a-button>
      <!-- <a-button @click="handleGocomparison">预测对比</a-button> -->
      <a-button @click="handleGoRunningStatus" v-hasPermi="['scp:scpSopShipmentForecast:goRunningStatus']">滚动业绩报表</a-button>

    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <ls-api-table
          ref="dataTable"
          :columns="columns"
          :selectedRows.sync="selectedRows"
          :multi-select="true"
          :tableProps="tableProps"
          :scroll="{ fixScreen: true, x: 1300 }"
          @selectedRowChange="selectedRowChange"
          :toolBox="{
                density: true, // 传入String时 初始化默认表格密度
                fullScreen: false,  // 是否需要全屏
                configKey: $TableKey.SHIPMENT_FORECAST_MANAGEMENT_LIST, // 表格方案配置唯一值
              }"
        >
          <template slot="netSubInventory" slot-scope="{ record }">
            <a-switch :disabled="false" :checked="record.netSubInventory === 'Y'" @change="statusOnChange(record)" />
          </template>
          <span slot="shipmentForecastName" slot-scope="{ record }">
            <a v-if="record.status==='已完成'||record.status==='已发布' || record.status==='已关闭'" @click="handleGoDetail(record)" class="ml10">{{ record.shipmentForecastName }}</a>
            <span v-else >{{ record.shipmentForecastName }}</span>

          </span>
          <span slot="status" slot-scope="{ record }">新建
            <a @click="handleGoStatus(record)" class="ml10" v-hasPermi="['scp:scpSopShipmentForecast:createShipmentForecast']">{{ record.status }}</a>
          </span>
          <template slot="timeFormat" slot-scope="{ text }">
            <span>{{ text && $moment(text).format('YYYY-MM-DD HH:mm:ss') }}</span>
          </template>
          <!-- 操作 -->
          <span slot="operation" slot-scope="{ record }">
            <a @click="handleEdit(record)" v-if="record.status !== '已关闭'" v-hasPermi="['scp:scpSopShipmentForecast:editShipmentForecast']">编辑</a>
            <a @click="handleDel(record)" class="ml10" v-hasPermi="['scp:scpSopShipmentForecast:deleteShipmentForecast']">删除</a>
            <a @click="handleClose(record)" v-if="record.status !== '已关闭'" class="ml10" v-hasPermi="['scp:scpSopShipmentForecast:closeShipmentForecast']">关闭</a>
            <a @click="handleSend(record)" v-if="record.status !== '已关闭'" class="ml10" v-hasPermi="['scp:scpSopShipmentForecast:publishShipmentForecast']">发布</a>
          </span>
        </ls-api-table>
        <startCalculation
          ref="startCalculation"
        />
      </div>
    </template>

  </ls-table-layout>
</template>

    <script>
import { listShipmentForecast, apiDeleteShipmentForecast, apiStartCalculate, apiStopCalculate, apiPublishShipmentForecast, apiCloseShipmentForecast } from '@/api/scp/shipmentForecast/shipmentForecastManagement'
import { generateLsTableResData } from '@/utils/util.js'
 import startCalculation from './components/startCalculation.vue'

export default {
  name: 'StandardUnit',
  components: {
    startCalculation
  },
  data () {
    return {
      // 表格多选
      selectedRowKeys: [],
      selectedRows: [],
      // 表格配置
      tableProps: {
        requestApi: generateLsTableResData(listShipmentForecast, true),
        pageCurrent: true
      },
      // 查询参数
      queryParams: {
        shipmentForecastName: undefined,
        shipmentForecastVersionList: undefined,
        statusList: undefined
      },
      baseUomFlagOptions: [
        {
          dictLabel: '是',
          dictValue: 'Y'
        },
        {
          dictLabel: '否',
          dictValue: 'N'
        }
      ],
      // 表格字段
      columns: [
        {
          title: '名称',
          ellipsis: true,
          dataIndex: 'shipmentForecastName',
          scopedSlots: { customRender: 'shipmentForecastName' },
          align: 'center',
          width: 180
        },
        {
          title: '版本',
          dataIndex: 'shipmentForecastVersion',
          ellipsis: true,
          width: 120,
          align: 'center'
        },
        {
          title: '参数版本',
          dataIndex: 'parameterVersion',
          width: 120,
          align: 'center'
        },
        {
          title: '预测版本',
          width: 120,
          dataIndex: 'shipmentForecastVersion',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '状态',
          width: 120,
          dataIndex: 'status',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '最后更新人',
          width: 120,
          dataIndex: 'updateName',
          align: 'center'
        },
        {
          title: '开始时间',
          width: 180,
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'timeFormat' },
          align: 'center'
        },
        {
          title: '最后更新日期',
          width: 180,
          dataIndex: 'updateTime',
          scopedSlots: { customRender: 'timeFormat' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '操作',
          width: 175,
          stickyFixed: 'right',
          align: 'center',
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' }
        }
      ]
    }
  },
  created () {
   // this.getLastSalesForecast()
   this.queryParams.shipmentForecastVersionList = this.$route.query.shipmentForecastVersion
  },
  mounted () {
    this.onSearch()
  },
  methods: {
    resetQuery () {
      this.queryParams = {
        shipmentForecastName: undefined,
        shipmentForecastVersionList: undefined,
        statusList: undefined
      }
      this.onSearch()
    },
    handleCalculation () {
      if (this.selectedRows.length > 1) {
        this.$message.error('选项不能超过1项')
        return
      }
      if (this.selectedRows.length === 0) {
        this.$message.error('请选择计算项')
        return
      }
      //  this.$refs.startCalculation.show();
      const id = this.selectedRows[0].id
      apiStartCalculate(id).then((response) => {
        if (response.code === 200) {
        } else {
          this.$message.error(response.msg)
        }
      })
      this.$message.success('启动计算成功')
      this.onSearch()
    },
    handleStopCalculation () {
      if (this.selectedRows.length > 1) {
        this.$message.error('选项不能超过1项')
        return
      }
      if (this.selectedRows.length === 0) {
        this.$message.error('请选择停止计算项')
        return
      }
      //  this.$refs.startCalculation.show();
      const id = this.selectedRows[0].id
      apiStopCalculate(id).then((response) => {
        if (response.code === 200) {
          this.$message.success('终止计算成功')
          this.onSearch()
        } else {
          this.$message.error(response.msg)
        }
      })
    },
    handleGoRunningStatus () {
      /** 检查只能选择一个 */
      if (this.selectedRowKeys.length > 1) {
        this.$message.error('滚动业绩报表的选择项不能大于1')
        return
      }
      if (this.selectedRowKeys.length === 0) {
        this.$message.error('请勾选其中一项')
        return
      }
      // this.$router.push({ path: `/shipmentForecastManagement/earningReport/${this.selectedRowKeys[0]}` })
      this.$router.push({ name: `earningReport`, query: { id: this.selectedRows[0].id, forecastPeriodFrom: this.selectedRows[0].forecastPeriodFrom, forecastPeriodTo: this.selectedRows[0].forecastPeriodTo, demandDepartment: this.selectedRows[0].demandDepartment } })
    },
    handleGocomparison () {
      this.$router.push({ path: `/shipmentForecastManagement/comparison/` })
    },
    handleDel (record) {
      const self = this
      this.$confirm({
        title: '提示',
        content: '你确定删除该记录吗？',
        okText: '确定',
        okType: 'danger',
        cancelText: '取消',
        onOk () {
          self.deleteShipmentForecast(record)
        },
        onCancel () {
        }
      });
    },
    handleClose (record) {
      this.$confirm({
        title: '提示',
        content: '你确定关闭该记录吗？',
        okText: '确定',
        okType: 'danger',
        cancelText: '取消',
        onOk: () => {
          this.confirmCloseShipmentForecast(record)
        },
        onCancel () {
        }
      });
    },
    handleSend (record) {
      if (record.status !== '已完成') {
        this.$message.error('尚未完成计算，请在完成计算后，再发布')
        return
      }
      const self = this
      this.$confirm({
        title: '提示',
        content: '你确定发布该记录吗？',
        okText: '确定',
        okType: 'danger',
        cancelText: '取消',
        onOk () {
          self.sendShipmentForecast(record)
        },
        onCancel () {
        }
      });
    },
    handleGoStatus (record) {
      this.$router.push({ path: `/shipmentForecastManagement/runningStatus/${record.id}` })
    },
    deleteShipmentForecast (record) {
      apiDeleteShipmentForecast(record.id).then((response) => {
        if (response.code === 200) {
          this.$message.success('删除成功')
          this.onSearch()
        } else {
          this.$message.error(response.msg)
        }
      })
    },
    confirmCloseShipmentForecast (record) {
      apiCloseShipmentForecast(record.id).then((response) => {
        if (response.code === 200) {
          this.$message.success('关闭成功')
          this.onSearch()
        } else {
          this.$message.error(response.msg)
        }
      })
    },
    sendShipmentForecast (record) {
      apiPublishShipmentForecast(record.id).then((response) => {
        if (response.code === 200) {
          this.$message.success('发布成功')
          this.onSearch()
        } else {
          this.$message.error(response.msg)
        }
      })
    },
    handleGoDetail (record) {
      this.$router.push({ path: `/shipmentForecastManagement/detail/${record.shipmentForecastName}/${record.shipmentForecastVersion}` })
    },
    handleEdit (record) {
      this.$router.push({ path: `/shipmentForecastManagement/editPage/${record.id}` })
    },
    handleAdd () {
      this.$router.push({ path: `/shipmentForecastManagement/editPage/` })
    },
    /** 行选中 */
    selectedRowChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },
    // 表单搜索
    onSearch () {
      this.$refs.dataTable.searchParams = this.queryParams
      this.$refs.dataTable.getData()
    },
    // 编辑-保存
    handleSave () {
      // if (!record.conversionRate || Number(record.conversionRate) <= 0) {
      //   this.$message.warning('折换不能为空且需大于0')
      //   return
      // }
      //  const tableData = this.$refs.dataTable.myDataSource;
      //   listUpdateNetSubInventory(tableData).then(response => {
      //     if (response.code === 200) {
      //       this.$message.success('保存成功')
      //       this.onSearch()
      //     } else {
      //       this.$message.error(response.msg)
      //     }
      //   })
    },
    // 取消
    handleCancel (record) {},
    statusOnChange (record) {
      record.netSubInventory = record.netSubInventory === 'Y' ? 'N' : 'Y'
    }
  }
}
</script>

    <style scoped lang="less">
.ml10 {
  margin-left: 10px;
}
</style>
